import { createStyles, Theme } from '@material-ui/core'

export const useSettlementKpiItemStyles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      maxWidth: 300,
      padding: theme.spacing(2),
      borderRadius: theme.spacing(1.5),
      border: '1px solid rgba(0,0,0,0.12)',
      backgroundColor: theme.palette.background.paper,
      transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
      [theme.breakpoints.down('sm')]: {
        maxWidth: 'none'
      }
    },
    // Estado clickable - hover
    clickable: {
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
        borderColor: theme.palette.primary.light,
        '& $valueText': {
          color: theme.palette.primary.main
        }
      },
      '&:active': {
        transform: 'translateY(0px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
      }
    },
    // Estado activo - relleno con color primario
    active: {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
      '& $titleText': {
        color: `${theme.palette.primary.contrastText} !important`
      },
      '& $valueText': {
        color: `${theme.palette.primary.contrastText} !important`
      },
      '& $descriptionText': {
        color: `${theme.palette.primary.contrastText} !important`,
        opacity: 0.85
      },
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        borderColor: theme.palette.primary.dark,
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 30px rgba(0,0,0,0.3)'
      }
    },
    // Estado desactivado - cuando value es 0
    disabled: {
      backgroundColor: theme.palette.grey[100],
      borderColor: theme.palette.grey[300],
      opacity: 0.65,
      '& $titleText': {
        color: `${theme.palette.grey[500]} !important`
      },
      '& $valueText': {
        color: `${theme.palette.grey[400]} !important`
      },
      '& $descriptionText': {
        color: `${theme.palette.grey[400]} !important`
      },
      '&:hover': {
        transform: 'none',
        boxShadow: 'none'
      }
    },
    detailFullWidth: {
      maxWidth: 'none'
    },
    titleBox: {
      marginBottom: theme.spacing(1.5)
    },
    titleText: {
      color: '#000000 !important',
      fontSize: '0.875rem',
      fontWeight: 500,
      letterSpacing: '0.01em'
    },
    valueText: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.1,
      color: theme.palette.text.primary,
      transition: 'color 0.25s ease'
    },
    contentRow: {
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 1,
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(4)
      }
    },
    descriptionText: {
      color: '#000000 !important',
      fontSize: '0.75rem',
      marginTop: theme.spacing(0.5),
      opacity: 0.75
    },
    skeleton: {
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center'
      },
      alignItems: 'flex-end',
      marginBottom: theme.spacing(1),
      borderRadius: theme.spacing(0.5)
    },
    leftContent: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center'
      },
      alignItems: 'flex-end',
      flex: 6
    },
    leftContentFull: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      marginRight: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        marginRight: 0,
        alignItems: 'center'
      },
      alignItems: 'flex-end'
    },
    rightContent: {
      flex: 6,
      alignItems: 'flex-start'
    }
  })
